var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomFields(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_4657_3356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4.49902C9 4.89685 9.15804 5.27838 9.43934 5.55968C9.72064 5.84099 10.1022 5.99902 10.5 5.99902C10.8978 5.99902 11.2794 5.84099 11.5607 5.55968C11.842 5.27838 12 4.89685 12 4.49902C12 4.1012 11.842 3.71967 11.5607 3.43836C11.2794 3.15706 10.8978 2.99902 10.5 2.99902C10.1022 2.99902 9.72064 3.15706 9.43934 3.43836C9.15804 3.71967 9 4.1012 9 4.49902Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.49902H9",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.49902H15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.99902C4.5 9.39685 4.65804 9.77838 4.93934 10.0597C5.22064 10.341 5.60218 10.499 6 10.499C6.39782 10.499 6.77936 10.341 7.06066 10.0597C7.34196 9.77838 7.5 9.39685 7.5 8.99902C7.5 8.6012 7.34196 8.21967 7.06066 7.93836C6.77936 7.65706 6.39782 7.49902 6 7.49902C5.60218 7.49902 5.22064 7.65706 4.93934 7.93836C4.65804 8.21967 4.5 8.6012 4.5 8.99902Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.99902H4.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.99902H15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.499C11.25 13.8968 11.408 14.2784 11.6893 14.5597C11.9706 14.841 12.3522 14.999 12.75 14.999C13.1478 14.999 13.5294 14.841 13.8107 14.5597C14.092 14.2784 14.25 13.8968 14.25 13.499C14.25 13.1012 14.092 12.7197 13.8107 12.4384C13.5294 12.1571 13.1478 11.999 12.75 11.999C12.3522 11.999 11.9706 12.1571 11.6893 12.4384C11.408 12.7197 11.25 13.1012 11.25 13.499Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.499H11.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.499H15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4657_3356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFields);
export default __webpack_public_path__ + "static/media/custom-fields.d6380fc8a3767603f6bf2397ef39457c.svg";
export { ForwardRef as ReactComponent };